export default __webpack_public_path__ + "media/zurb/img/growth-design/marketing-sites-8090710eeac13eb0fdb9d5b147eed1fb.png";